import React, {useEffect, useState, useRef} from "react";
import {
  View,
  Text,
  StyleSheet,
  Platform,
  TouchableOpacity,
  Animated,
  Easing,
} from "react-native";
import {Color, globalFontStyle} from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import {useDispatch, useSelector} from "react-redux";
import {Button} from "../../../components/core/Button";
import {Input} from "../../../components/core/Input";
import {Controller, useForm, useFormState} from "react-hook-form";
import FastImage from "../../../common/FastImage";
import {down_arrow, up_arrow} from "../../../utils/images";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import DropdownComponent from "../../../commonComponents/Forms/dropdownForm";
import {Network} from "../../../utils/network";
import {getUser} from "../redux/profile.action";
import {globalConfigurableData} from '../../../utils/globalConstant';
import {isMobile} from '../../../utils/commonMethods';

const KycConfigurable = ({BankDetailsData = null}) => {
  const {
    control,
    formState: {errors, isValid, isSubmitting},
    handleSubmit,
    setValue,
  } = useForm({mode: "onChange"});
  const {dirtyFields} = useFormState({
    control,
  });

  const {
    control: controlSubForm,
    formState: {errors: errors2, isValid: isValid2},
    getValues,
    trigger,
    reset: resetSubForm,
  } = useForm({
    mode: "onChange",
  });

  const [fieldsConfig, setFieldsConfig] = useState([]);
  const [showProfileDetials, setShowProfileDetails] = useState(true);
  const [bankDropdownList, setBankDropdownList] = useState([]);
  const [bankArrIndex, setBankArrIndex] = useState();
  const [dependentFields, setDependentFields] = useState([]);
  const [contentHeight, setContentHeight] = useState(0);
  const animatedHeight = useRef(new Animated.Value(1)).current;

  const dispatch = useDispatch();
  let userInfo = useSelector(({profile}) => profile.profileData);

  useEffect(() => {
    setFieldsConfig(userInfo?.withdrawConfig?.pg?.[1]?.fields);
  }, [userInfo]);

  const {isDirty} = useFormState({
    control,
  });

  const getBankList = async () => {
    let index1;
    let element;
    fieldsConfig?.forEach((data, i) => {
      if (data.values && data.isAsync) {
        index1 = i;
        element = data;
      }
    });
    if (element) {
      const list = await Network.getBankList(element?.values);
      if (list?.data) {
        setBankArrIndex(index1);
        setBankDropdownList(list?.data?.options);
        onDropdownChange(element, index1);
        setValue(element?.key, list?.data?.options?.[0]?.key);
      }
    }
  };

  useEffect(() => {
    getBankList();
  }, [fieldsConfig]);

  const [apiSuccess, setApiSuccess] = useState("");
  const [respError, setResponseError] = useState("");

  const formatPanNumber = (value) => {
    if (!value) return value;
    return value.toUpperCase();
  };

  const formatIfscCode = (value) => {
    if (!value) return value;
    return value.toUpperCase();
  };

  const onClickBankUpdate = async details => {
    if (isValid2) {
      const requestPayload = {
        ...details,
        ...getValues(),
        pg: "direct24",
      };
      const res = await Network.addBankDetails(requestPayload);
      if (!res?.data?.success) {
        //dispatch(getBankDetails());
        setResponseError(res?.data?.error);
      } else {
        // trackAppsflyerEvent("kyc_success", {
        //   status: "success",
        //   datetime: new Date(),
        //   method: "",
        // });
        //dispatch(getBankDetails());
        // trackMoengageEvent("KYC Details", {
        //   Status: "complete",
        //   PAN: details.PANNO,
        //   IFSC: details.ifsc,
        //   AccountNo: details.accountNumberCheck,
        //   Time: new Date(),
        // });
        setApiSuccess("Your KYC verification has been successfull!");
        dispatch(getUser());
      }
    } else {
      trigger();
    }
  };

  useEffect(() => {
    if (isDirty) {
      setResponseError("");
    }
  }, [isDirty]);

  const onDropdownChange = (item, index1) => {
    if (fieldsConfig[bankArrIndex || index1].dependents[item.label]) {
      resetSubForm("");
      setDependentFields(
        fieldsConfig[bankArrIndex || index1].dependents[item.label].fields,
      );
    } else {
      resetSubForm("");
      setDependentFields(
        fieldsConfig[bankArrIndex || index1].dependents["all"].fields,
      );
    }
  };

  const toggleDetails = () => {
    const toValue = !showProfileDetials ? 1 : 0;
    setShowProfileDetails(!showProfileDetials);

    Animated.timing(animatedHeight, {
      toValue,
      duration: 300,
      easing: Easing.bezier(0.4, 0, 0.2, 1),
      useNativeDriver: false,
    }).start();
  };

  return (
    <View>
      <View style={styles.eventDetailsBox}>
        <TouchableOpacity
          onPress={toggleDetails}
          activeOpacity={0.7}>
          <View style={styles.eventDetailTitle}>
            <View style={{flex: 1}}>
              <FormTextLabel
                labelStyles={{
                  ...globalFontStyle.appFontSubTextBold,
                  color: globalConfigurableData.primaryTextColor1,
                  fontSize: isMobile() ? 14 : 16,
                  lineHeight: isMobile() ? 14 : 16,
                }}
                label={"Payment Details"}
              />
              <FormTextLabel
                labelStyles={{
                  ...globalFontStyle.appFontSmallText,
                  color: Colors.grey7,
                  marginTop: 4,
                }}
                label={"Please make sure that your bank details are matching with your KYC details for a hassel-free withdrawal process."}
              />
            </View>
            <Animated.View style={{
              transform: [{
                rotate: animatedHeight.interpolate({
                  inputRange: [0, 1],
                  outputRange: ['0deg', '180deg']
                })
              }]
            }}>
              <FastImage
                source={down_arrow()}
                style={{width: 18, height: 18}}
              />
            </Animated.View>
          </View>
        </TouchableOpacity>

        <Animated.View style={{
          height: animatedHeight.interpolate({
            inputRange: [0, 1],
            outputRange: [0, contentHeight]
          }),
          opacity: animatedHeight.interpolate({
            inputRange: [0, 1],
            outputRange: [0, 1]
          }),
          overflow: 'hidden'
        }}>
          <View
            onLayout={(event) => {
              const {height} = event.nativeEvent.layout;
              setContentHeight(height);
            }}
            style={styles.contentContainer}>
            {fieldsConfig?.map((item, key) => {
              return (
                <View key={item.key}>
                  {!item.isDropdown ? (
                    <Input
                      name={item?.key}
                      placeholder={item?.placeholder}
                      control={controlSubForm}
                      label={item?.label}
                      variant="default"
                      size="default"
                      rules={{
                        required: item?.validations?.required && item?.messages?.required,
                        pattern: {
                          value: new RegExp(item?.validations?.pattern),
                          message: item?.messages?.pattern,
                        },
                      }}
                      formatter={
                        item.key?.toLowerCase().includes('pan') || item.label?.toLowerCase().includes('pan')
                          ? 'pan'
                          : item.key?.toLowerCase().includes('ifsc') || item.label?.toLowerCase().includes('ifsc')
                          ? 'ifsc'
                          : undefined
                      }
                    />
                  ) : (
                    <Controller
                      control={controlSubForm}
                      name={item.key}
                      rules={{
                        required: item?.validations?.required && item?.messages?.required,
                      }}
                      defaultValue={item?.values[0]?.key}
                      render={({field: {value, onChange}}) => (
                        <DropdownComponent
                          onDropdownChange={item1 => {
                            onDropdownChange(item, item1);
                            onChange(item1?.key);
                          }}
                          data={item?.values}
                          buttonStyle={styles.dropdownStyle}
                          buttonTextStyle={styles.dropdownTextStyle}
                          dropdownStyle={styles.dropdownListStyle}
                          rowStyle={styles.dropdownRowStyle}
                          rowTextStyle={styles.dropdownRowTextStyle}
                        />
                      )}
                    />
                  )}
                </View>
              );
            })}
            {dependentFields?.map((item, key) => {
              return (
                <View key={item.key}>
                  {!item.isDropdown ? (
                    <Input
                      name={item?.key}
                      placeholder={item?.placeholder}
                      control={controlSubForm}
                      label={item?.label}
                      variant="default"
                      size="default"
                      rules={{
                        required: item?.validations?.required && item?.messages?.required,
                        pattern: {
                          value: new RegExp(item?.validations?.pattern),
                          message: item?.messages?.pattern,
                        },
                      }}
                      formatter={
                        item.key?.toLowerCase().includes('pan') || item.label?.toLowerCase().includes('pan')
                          ? 'pan'
                          : item.key?.toLowerCase().includes('ifsc') || item.label?.toLowerCase().includes('ifsc')
                          ? 'ifsc'
                          : undefined
                      }
                    />
                  ) : (
                    <Controller
                      control={controlSubForm}
                      name={item.key}
                      rules={{
                        required: item?.validations?.required && item?.messages?.required,
                      }}
                      defaultValue={item?.values[0]?.key}
                      render={({field: {value, onChange}}) => (
                        <DropdownComponent
                          onDropdownChange={item1 => {
                            onDropdownChange(item, item1);
                            onChange(item1?.key);
                          }}
                          data={item?.values}
                          buttonStyle={styles.dropdownStyle}
                          buttonTextStyle={styles.dropdownTextStyle}
                          dropdownStyle={styles.dropdownListStyle}
                          rowStyle={styles.dropdownRowStyle}
                          rowTextStyle={styles.dropdownRowTextStyle}
                        />
                      )}
                    />
                  )}
                </View>
              );
            })}

            {/* <FormTextLabel
            labelStyles={{
              ...globalFontStyle.appFontSmallText,
              color: Colors.grey,
              paddingBottom: 20,
            }}
            label={
              'Please double-check your details before submitting to avoid delays in withdrawal. Please note that PAN details cannot be changed post-submission.'
            }
          /> */}

            {respError ? (
              <FormTextLabel
                labelStyles={styles.errorText}
                label={respError ? respError : ""}
              />
            ) : null}
            {apiSuccess ? (
              <FormTextLabel
                labelStyles={[styles.errorText, {color: Color.green}]}
                label={apiSuccess ? apiSuccess : ""}
              />
            ) : null}

            <Button
              variant="primary"
              onPress={handleSubmit(onClickBankUpdate)}
              translate={true}
            >
              Submit
            </Button>
            <View style={{paddingBottom: 20}}></View>
          </View>
        </Animated.View>
      </View>
    </View>
  );
};

export default KycConfigurable;

const styles = StyleSheet.create({
  eventDetailsBox: {
    marginTop: 12,
    shadowColor: "#666",
    shadowOffset: { width: 0, height: -2 },
    shadowOpacity: 0.05,
    shadowRadius: 1,
    elevation: 1,
    backgroundColor: Colors.bgWhite,
  },
  eventDetailTitle: {
    height: 48,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: 'center',
    paddingHorizontal: 16,
  },
  errorText: {
    ...globalFontStyle.appFontSmallText,
    color: "#FF0000",
  },
  dropdownStyle: {
    flex: 1,
    height: '100%',
    paddingHorizontal: 12,
    backgroundColor: Colors.bgWhite,
    borderWidth: 0,
  },
  dropdownTextStyle: {
    ...globalFontStyle.appFontBody,
    fontSize: 14,
    color: globalConfigurableData.primaryTextColor1,
    textAlign: 'left',
  },
  dropdownListStyle: {
    borderRadius: 6,
    borderColor: globalConfigurableData.borderColor,
    marginTop: 4,
  },
  dropdownRowStyle: {
    borderBottomColor: globalConfigurableData.borderColor,
    height: 46,
    paddingHorizontal: 12,
  },
  dropdownRowTextStyle: {
    ...globalFontStyle.appFontBody,
    fontSize: 14,
    color: globalConfigurableData.primaryTextColor1,
  },
  contentContainer: {
    paddingTop: 8,
    paddingHorizontal: 16,
  },
});
